'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _shifty = require('shifty');

var _shifty2 = _interopRequireDefault(_shifty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProgressProvider = (_temp = _class = function (_Component) {
  _inherits(ProgressProvider, _Component);

  function ProgressProvider(props) {
    _classCallCheck(this, ProgressProvider);

    var _this = _possibleConstructorReturn(this, (ProgressProvider.__proto__ || Object.getPrototypeOf(ProgressProvider)).call(this, props));

    _this.state = {
      active: false,
      value: 0
    };
    return _this;
  }

  _createClass(ProgressProvider, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._tweenable = new _shifty2.default();
      if (this.props.isLoading) {
        this.begin();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.isLoading && nextProps.isLoading) {
        this.begin();
      } else if (this.props.isLoading && !nextProps.isLoading) {
        this.finish();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._tweenable.stop();
      this._tweenable = null;
    }
  }, {
    key: 'begin',
    value: function begin() {
      var _this2 = this;

      this._tweenable.stop();
      this.setState({
        active: true,
        value: 0
      });

      this._tweenable.tween({
        from: { value: 0 },
        to: { value: 45 },
        duration: 2000,
        easing: 'easeOutQuad',
        step: function step() {
          return _this2.updateValue();
        },
        finish: function finish() {
          _this2.updateValue();
          _this2._tweenable.tween({
            from: { value: _this2._tweenable.get().value },
            to: { value: 80 },
            duration: 20000,
            easing: 'easeOutQuad',
            step: function step() {
              return _this2.updateValue();
            },
            finish: function finish() {
              return _this2.updateValue();
            }
          });
        }
      });
    }
  }, {
    key: 'finish',
    value: function finish() {
      var _this3 = this;

      this._tweenable.stop();
      this._tweenable.tween({
        from: { value: this.state.value },
        to: { value: 100 },
        duration: 200,
        easing: 'easeOutQuad',
        step: function step() {
          return _this3.updateValue();
        },
        finish: function finish() {
          _this3.setState({
            value: _this3._tweenable.get().value,
            active: false
          });
        }
      });
    }
  }, {
    key: 'updateValue',
    value: function updateValue() {
      this.setState({
        value: this._tweenable.get().value
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var _state = this.state,
          active = _state.active,
          value = _state.value;


      var child = _react.Children.only(children);
      if (!child) {
        return null;
      }

      var progressProps = {
        active: active,
        value: value
      };

      var enhancedChild = _react2.default.cloneElement(child, {
        progress: progressProps
      });

      return enhancedChild;
    }
  }]);

  return ProgressProvider;
}(_react.Component), _class.propTypes = {
  // isLoading: _react.PropTypes.bool,
  // children: _react.PropTypes.element
}, _temp);
exports.default = ProgressProvider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/reprogressbars/lib/components/ProgressProvider.js
// module id = 22
// module chunks = 0